import { service } from '../../../../helpers/http'

export const ActionIndexTeacherTimeBank = (context, payload) => {
    return service({
        module: 'timeSheet',
        action: 'indexTeacherTimeBank',
        payload: payload
    })
}

export const ActionShowTeacherTimeBank = (context, payload) => {
    return service({
        module: 'timeSheet',
        action: 'showTeacherTimeBank',
        payload: payload
    })
}

export const ActionSummaryTeacherTimeBank = (context, payload) => {
    return service({
        module: 'timeSheet',
        action: 'summaryTeacherTimeBank',
        payload: payload
    })
}

export const ActionExportTeacherTimeBank = (context, payload) => {
    return service({
        module: 'timeSheet',
        action: 'exportTeacherTimeBank',
        payload: payload
    })
}
